import Option from '@/modules/common/models/option/option.ts';

export default class DocumentOption extends Option<number> {
  constructor(response: any, enabledKey?: string) {
    super(response, 'DOC_ID', 'Содержание', enabledKey);
  }

  protected getLabel(response: any, key: string) {
    return `№${response['DOC_ID']} — ${response['Тип']} — ${response[key].replace(/\s+/g, ' ')}`;
  }
}
